import type { ReactNode } from "react";
import { RecapPageSkeleton } from "./SpaceLoadingSkeletons";

export function SpaceRecapStatus({
  status,
  onRetry,
}: {
  status: string;
  onRetry: () => void;
}) {
  if (status === "loading")
    return (
      <div role="status" aria-label="Loading Space review">
        <RecapPageSkeleton />
      </div>
    );
  if (status === "error")
    return (
      <div role="alert" className="et-recap-error">
        <p>Could not load this Space review.</p>
        <button type="button" onClick={onRetry}>
          Try again
        </button>
      </div>
    );
  return null;
}

export function SpaceRecapHeader({
  name,
  startedAt,
  onViewCanvas,
}: {
  name: string;
  startedAt: string | null;
  onViewCanvas: () => void;
}) {
  return (
    <header className="et-recap-heading">
      <div>
        <span className="et-recap-eyebrow">Closed Space review</span>
        <h1>{name}</h1>
        <p>
          {startedAt
            ? new Date(startedAt).toLocaleString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
              })
            : "Start time unavailable"}
        </p>
      </div>
      <button
        type="button"
        className="et-recap-canvas-link"
        onClick={onViewCanvas}
      >
        View Canvas
      </button>
    </header>
  );
}

export function SpaceRecapMetrics({
  items,
}: {
  items: { label: string; value: ReactNode }[];
}) {
  return (
    <dl className="et-recap-metrics">
      {items.map(({ label, value }) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}
